// extracted by mini-css-extract-plugin
export var downArrow = "_ab-0";
export var label = "_ab-1";
export var treatmentCard = "_ab-3";
export var upArrow = "_ab-2";